export default {
    getActivities: (state) => state.activities,
    getMacroActivities: (state) => state.macroActivities,
  }